var map = {
	"./2018/config.json": [
		319,
		4
	],
	"./2018/data-map-belgium.json": [
		593,
		40
	],
	"./2018/data-map-world.json": [
		594,
		41
	],
	"./2018/data.json": [
		320,
		5
	],
	"./2019/config.json": [
		321,
		6
	],
	"./2019/data-map-belgium.json": [
		595,
		42
	],
	"./2019/data-map-world.json": [
		596,
		43
	],
	"./2019/data.json": [
		322,
		7
	],
	"./2020/config.json": [
		323,
		8
	],
	"./2020/data-map-belgium.json": [
		597,
		44
	],
	"./2020/data-map-world.json": [
		598,
		45
	],
	"./2020/data.json": [
		324,
		9
	],
	"./2021/config.json": [
		325,
		10
	],
	"./2021/data-map-belgium.json": [
		599,
		46
	],
	"./2021/data-map-world.json": [
		600,
		47
	],
	"./2021/data.json": [
		326,
		11
	],
	"./2022/config.json": [
		327,
		12
	],
	"./2022/data-map-belgium.json": [
		601,
		48
	],
	"./2022/data-map-world.json": [
		602,
		49
	],
	"./2022/data.json": [
		328,
		13
	],
	"./2022/raw.json": [
		603,
		50
	],
	"./2023/config.json": [
		329,
		14
	],
	"./2023/data-map-belgium.json": [
		604,
		51
	],
	"./2023/data-map-world.json": [
		605,
		52
	],
	"./2023/data.json": [
		330,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 318;
module.exports = webpackAsyncContext;